import React from 'react';

const PHONE_DISPLAY = '+91 95211 15800';
const PHONE_TEL = '+919521115800';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-cream-50 to-cream-100 flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="max-w-xl animate-fade-in">
        <p className="font-display text-sm uppercase tracking-[0.2em] text-gold-600 mb-6">
          Venue Walks
        </p>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-semibold text-burgundy-900 leading-tight mb-6">
          Evolving into something awesome for the event industry.
        </h1>
        <p className="font-body text-cream-800/90 text-lg mb-10">
          We are building what comes next. Until then, we would love to hear from you.
        </p>
        <a
          href={`tel:${PHONE_TEL}`}
          className="inline-flex items-center justify-center rounded-lg bg-gold-500 px-8 py-4 font-body font-semibold text-white shadow-lg transition hover:bg-gold-600 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2"
        >
          Reach us at {PHONE_DISPLAY}
        </a>
      </div>
    </div>
  );
}

export default App;
